/**
 * 定义压力线类
 */
class PRESSURELINE {
    /**
     * 压力线类构造函数
     * @param {Array<Object>} datas 压力线数据集合
     */
    constructor(datas = []) {
        this.datas = datas;
        this.sellSeriesOptions = this.initSeriesOption(true);
        this.buySeriesOptions = this.initSeriesOption(false);
    }

    /**
     * 创建series选项
     * @param {Boolean} isSell 是否是卖出
     * @returns {Object} 返回创建的选项
     */
    initSeriesOption(isSell) {
        let baseColor = isSell ? '204,20,20' : '41,172,78';
        let colors = [];
        let start = 25;
        let end = 100;
        // 上下各5根压力线
        let interval = Math.round((end - start) / 5);
        for (let i = start; i < end; i = i + interval) {
            colors.push(`rgba(${baseColor}, 0.${i})`);
        }
        return colors.map(color => {
            return {
                name: '',
                type: 'line',
                data: [],
                smooth: true,
                showSymbol: false,
                lineStyle: {
                    color,
                    opacity: 0.5,
                    width: 1
                }
            };
        });
    }

    /**
     * 因为数据缺失，所以需要按照K线的数据量补充
     * @param {Array<String>} times 日期时间序列
     */
    calculate(times) {
        this.datas.forEach(oneSeries => {
            oneSeries.datas = times.map(datetime => {
                let value = null;
                oneSeries.datas.some(data => {
                    if (data.datetime.toString() === datetime) {
                        value = data.value;
                        return true;
                    }
                    return false;
                });
                return value;
            });
        });
    }

    /**
     * 生成Series选项
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption() {
        return this.datas.map(data => {
            let key = data.type + 'SeriesOptions';
            let option = this[key][data.index];
            option.name = (data.type === 'sell' ? '压力线' : '支撑线') + (data.index + 1);
            option.data = data.datas;
            return option;
        });
    }
}

export default PRESSURELINE;



// WEBPACK FOOTER //
// ./src/controller/series/PRESSURELINE.js